import { Component } from 'src/utils';
import template from './nav-menu.html';

@Component({
  controllerAs: 'ctrl',
  template
})

export default class navMenu {

  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'authService',
    'orderService',
    '$cookies'

  ];

  constructor($scope, $ngRedux, $state, $auth, $order,  $cookies) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$order = $order;
    this.$state = $state;
    this.$auth = $auth;
    let guestStore = null;
    try {
      guestStore = sessionStorage.getItem('guestStoreName');
    }
    catch (e) {
      guestStore = $cookies.get('guestStoreName');
    }
    this.$auth.getStoreDetail(guestStore);
    $order.getGiftCards();
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    let obj = {
      profile: state.auth.profile,
      list: state.order.categories,
      giftCards : state.order.giftCards
    };
    if (!obj.profile.store) {
      obj.profile = {'store': state.auth.storeDetail};
    }
    return obj;
  }
  doLogout() {
    this.$auth.logout(this.profile);
  }
  goTo() {
    // console.log('go to');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/nav-menu/nav-menu.js